import {
  footerBaseStyle,
  TFooterTheme,
} from '../../base/customComponents/footer';
import { TStyleConfig } from '../../base/types';
import footer from '../../../assets/wellbet/images/footer/footer.png';

export const Footer: TStyleConfig<TFooterTheme> = {
  baseStyle: {
    ...footerBaseStyle,
    footer: {
      ...footerBaseStyle.footer,
      pb: ['32', null, 'unset'],
      py: ['0', '6'],
      pt: '6',
      bg: ['gray.200', null, 'transparent'],
      bgImage: [`url(${footer})`, null, ''],
      bgSize: 'cover',
      bgPos: 'bottom',

      color: 'white',
    },
    stackGap: '1',
    footerBar: {
      display: 'flex',
      flexDir: ['column', null, 'row'],
      h: '70px',
      pr: ['0', null, '3'],
      mb: '0',
      borderRadius: 'md',
      alignItems: 'center',
      justifyContent: ['center', null, 'unset'],
      '& > img': {
        maxW: '250px',
        h: '35px',
        ml: '0',
      },
    },
    footerLink: {
      color: 'gamma.500',
      textTransform: 'lowercase',
      cursor: 'pointer',
      display: 'inline-block',
      mt: '0',
      whiteSpace: 'nowrap',
    },
    footerLinkTel: {
      color: 'gamma.500',
      textTransform: 'lowercase',
      cursor: 'pointer',
      display: 'inline-block',
      mt: '0',
      whiteSpace: 'nowrap',
    },
    customFooterLink: {
      color: 'gamma.500',
      textTransform: 'capitalize',
      cursor: 'pointer',
      display: 'inline-block',
      mt: '0',
      whiteSpace: 'nowrap',
    },
    footerLinks: {
      mt: '3',
      ml: ['unset', null, 'auto'],
      pb: ['4', null, '0'],
      alignItems: 'center',
      justifyContent: ['space-around', null, 'unset'],
      color: 'white',
      fontWeight: 'medium',
      flexDir: ['row', null, 'unset'],
      display: 'inline-flex',
    },
    footerContentContainer: {
      px: ['2.5', 'unset'],
      gap: '6',
      ...footerBaseStyle.footerContentContainer,
      bg: [null, null, 'transparent'],
      justifyContent: 'space-between',
      '&': {
        flexDirection: ['column', null, 'column-reverse'],
      },
    },
    nav: {
      ...footerBaseStyle.nav,
      fontSize: 'sm',
      fontWeight: 'medium',
      minW: [null, null, '370px'],
      mt: ['6', 'unset'],
      display: ['flex', 'grid'],
      gridTemplateColumns: '1fr 1fr 1fr',
      gridTemplateRows: 'auto',
      columnGap: '28',
      rowGap: '4',
      alignItems: ['center', 'end'],
      gridTemplateAreas: `
        ". ."
      `,

      '> a': {
        color: 'inherit',
      },
    },
    blurb: {
      ...footerBaseStyle.blurb,
      flex: 'unset',
      textAlign: 'left',
      color: 'alpha.200',
      width: 'unset',
      mb: '0',
      ml: [null, '0'],
      mr: [null, null, '4'],
    },
    blurbHeading: {
      ml: 'unset',
      mt: 'unset',
    },
    blurbHeadingAge: {
      ...footerBaseStyle.blurbHeadingAge,
      borderColor: 'blackAlpha.50',
      border: '4px',
      mb: '2',
      boxSize: '8',
      fontSize: 'xs',
    },
    blurbHeadingThink: {
      fontSize: 'xs',
      fontWeight: 'bold',
      mb: '4',
    },
    blurbContent: {
      ...footerBaseStyle.blurbContent,
      ml: 'unset',
      mr: [null, null, 'auto'],
    },
    copyright: {
      ...footerBaseStyle.copyright,
      textAlign: ['center', 'left'],
      mt: ['7'],
      px: ['8', 'unset'],
      py: '0',
      fontWeight: ['semibold', 'medium'],
    },
    container: {
      '&&': {
        px: ['0', '2'],
      },
    },
    emailUs: {
      fontSize: 'md',
      fontWeight: 'bold',
    },
  },
  sizes: {},
  variants: {},
};
